(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"));
	else if(typeof define === 'function' && define.amd)
		define("Gravatar", ["React"], factory);
	else if(typeof exports === 'object')
		exports["Gravatar"] = factory(require("React"));
	else
		root["Gravatar"] = factory(root["React"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__24__) => {
return 